import { useEffect } from 'react';
import { useAppContext, APP_PAGE_STORAGE_KEY } from '../../../contexts/AppContext';
import { usePermissions } from '../../../hooks/usePermissions';
import { isAdminOnlyPage } from '../../../utils/routeUtils';

/**
 * Keeps members off owner/admin settings (integrations, channels, CRM config).
 * Backend + RLS remain source of truth — this is UX only.
 */
export function useMemberPageGuard(): void {
  const { currentPage, setCurrentPage } = useAppContext();
  const { isMember } = usePermissions();

  useEffect(() => {
    if (!isMember || !isAdminOnlyPage(currentPage)) return;

    setCurrentPage('dashboard');
    try {
      localStorage.setItem(APP_PAGE_STORAGE_KEY, 'dashboard');
    } catch {
      /* ignore quota errors */
    }
  }, [currentPage, isMember, setCurrentPage]);
}
